import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "variantColor", "variant", "withMask", "withLeftOverflow", "loop", "labels", "onSlideChange", "hideNextSlideGroup", "swiperConfig"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as r, jsxs as F } from "react/jsx-runtime";
import l, { useState as f, useCallback as o, startTransition as K, useMemo as q } from "react";
import { SwiperSlide as A, Swiper as D } from "swiper/react";
import { c as a } from "../clsx-OuTLNxxd.js";
import { match as J } from "ts-pattern";
import { defaultLabels as U, SliderControls as Y } from "./SliderControls.js";
import { PaginationButton as C } from "../PaginationButton/PaginationButton.js";
const z = "Slider-module_carousel__I4r2U",
  H = "Slider-module_with-mask__AkT5R",
  Q = "Slider-module_mask__Wrjc1",
  X = "Slider-module_hide-next-slide-group__K55mI",
  Z = "Slider-module_left-overflow__h4Mho",
  $ = "Slider-module_carousel-inline__biOwI",
  ee = "Slider-module_carousel-inline-with-controls__gn5Bj",
  ie = "Slider-module_button-prev-inline__LiYGf",
  se = "Slider-module_hidden__xNS0o",
  re = "Slider-module_button-next-inline__TJmjK",
  e = {
    carousel: z,
    withMask: H,
    mask: Q,
    hideNextSlideGroup: X,
    leftOverflow: Z,
    carouselInline: $,
    carouselInlineWithControls: ee,
    buttonPrevInline: ie,
    hidden: se,
    buttonNextInline: re
  },
  ne = _ref => {
    let {
      children: d
    } = _ref;
    return /* @__PURE__ */r(l.Fragment, {
      children: d
    });
  },
  fe = /* @__PURE__ */l.memo(ne),
  v = {
    //lazy: lazyOptions,
    spaceBetween: 24,
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      //MD
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 24
      },
      //LG
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 24
      },
      //XL
      1280: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 48
      }
    }
  },
  le = {
    //lazy: lazyOptions,
    spaceBetween: 24,
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      480: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 24
      },
      //MD
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 24
      },
      //LG
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 24
      },
      //XL
      1280: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 24
      }
    }
  },
  te = {
    //lazy: lazyOptions,
    watchSlidesProgress: !0,
    spaceBetween: 24,
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      //MD
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      //LG
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3
      },
      //XL
      1280: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  oe = {
    //lazy: lazyOptions,
    spaceBetween: 24,
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      //MD
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 24
      },
      //LG
      1024: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 24
      },
      //XL
      1280: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 48
      }
    }
  },
  ae = {
    //lazy: lazyOptions,
    spaceBetween: 24,
    slidesPerView: 1,
    slidesPerGroup: 1
  },
  de = d => {
    const {
        children: p,
        variantColor: G = "neutral05",
        variant: n = "normal",
        withMask: g = !0,
        withLeftOverflow: B = !1,
        loop: t = !1,
        labels: k,
        onSlideChange: w,
        hideNextSlideGroup: x = !1,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        swiperConfig: ce
      } = d,
      I = _objectWithoutProperties(d, _excluded),
      V = J(d).with({
        variant: "normal"
      }, () => v).with({
        variant: "inline"
      }, () => te).with({
        variant: "wide"
      }, () => oe).with({
        variant: "full"
      }, () => ae).with({
        variant: "compact"
      }, () => le).with({
        variant: "custom"
      }, i => i.swiperConfig).otherwise(() => v),
      [N, M] = f(0),
      [W, O] = f(1),
      [s, j] = f(),
      _ = o(() => {
        s && s.slidePrev();
      }, [s]),
      b = o(() => {
        s && s.slideNext();
      }, [s]),
      E = o(i => {
        K(() => {
          j(i);
        });
      }, []),
      y = o(i => {
        const u = Math.ceil(i.realIndex / (i.params.slidesPerGroup || 1));
        M(u), w && w(u);
      }, [w]),
      L = o((i, u) => {
        O(i.params.slidesPerGroup || 1);
      }, []),
      R = l.Children.count(p),
      m = Math.ceil(R / W),
      c = m > 1,
      T = q(() => l.Children.map(p, i => {
        if (l.isValidElement(i)) return /* @__PURE__ */r(A, {
          style: s ? void 0 : {
            maxWidth: "calc(100% / 3)"
          },
          children: i
        });
      }), [p, s]),
      P = !!(s !== null && s !== void 0 && s.isBeginning),
      h = !!(s !== null && s !== void 0 && s.isEnd),
      S = k || U;
    return /* @__PURE__ */r(l.Fragment, {
      children: m > 0 && /* @__PURE__ */F("div", _objectSpread(_objectSpread({
        className: a(e.carousel, {
          [e.carouselNormal]: n == "normal",
          [e.carouselWide]: n == "wide",
          [e.carouselInline]: n == "inline",
          [e.carouselInlineWithControls]: n == "inline" && c,
          [e.withMask]: g
        })
      }, I), {}, {
        children: [c && n === "inline" && /* @__PURE__ */r(C, {
          dataContentPiece: "slider_previous_button",
          arrow: "left",
          disabled: P && !t,
          onClick: _,
          "aria-label": S.previous,
          role: "button",
          className: a(e.buttonPrevInline, {
            [e.hidden]: P
          })
        }), /* @__PURE__ */r("div", {
          className: a(e.mask, {
            [e.leftOverflow]: B
          }),
          children: /* @__PURE__ */r("div", {
            className: e.sliderContainer,
            children: /* @__PURE__ */r(D, _objectSpread(_objectSpread({}, V), {}, {
              slideToClickedSlide: !0,
              uniqueNavElements: !1,
              loop: t,
              centerInsufficientSlides: n !== "inline",
              passiveListeners: !0,
              onSlideChange: y,
              onSwiper: E,
              onBreakpoint: L,
              className: a({
                [e.hideNextSlideGroup]: x
              }),
              children: T
            }))
          })
        }), c && n === "inline" && /* @__PURE__ */r(C, {
          dataContentPiece: "slider_next_button",
          arrow: "right",
          disabled: h && !t,
          onClick: b,
          "aria-label": S.next,
          role: "button",
          className: a(e.buttonNextInline, {
            [e.hidden]: h
          })
        }), c && n !== "inline" && /* @__PURE__ */r(Y, {
          variantColor: G,
          currentSlideIndex: N,
          totalPages: m,
          isBeginning: P && !t,
          isEnd: h && !t,
          labels: S,
          prevSlide: _,
          nextSlide: b
        })]
      }))
    });
  },
  _e = de;
export { _e as Slider, fe as SliderSlide };